import { IGetAllEquipamentoMedicaoListUseCase } from "../../../presentation/useCases/read/get_all_equipamento_medicao_list_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { EquipamentoMedicaoList } from "../../models/EquipamentoMedicao_List";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * GetAllEquipamentoMedicaoListUseCase
 */

export class GetAllEquipamentoMedicaoListUseCase
  extends BasePaginatedUseCase<EquipamentoMedicaoList>
  implements IGetAllEquipamentoMedicaoListUseCase {

  constructor(private readonly repository: IEquipamentoMedicaoRepository) {
    super();
  }

  async getAllEquipamentoMedicaoList(
    idObra?: number,
    idsCentroCusto?: number[],
    status?: string | null,
    equipamento?: string | null,
    responsavelPeloEquipamento?: string | null,
    dataCalibracaoDe?: Date | null,
    dataCalibracaoAte?: Date | null,
    page?: number | null,
    rowsPerPage?: number | null,
  ): Promise<void> {
    const response = await this.repository.getAllEquipamentoMedicaoList(
      idObra ?? null,
      idsCentroCusto,
      status,
      equipamento,
      responsavelPeloEquipamento,
      dataCalibracaoDe,
      dataCalibracaoAte,
      page,
      rowsPerPage
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
